/* eslint-disable react/no-array-index-key */
import { Box, TextField } from "@engaging-tech/components"
import React, { useEffect, useState } from "react"

const ShortText = ({ fields, onAnswer, initialValue }) => {
  const getInitialValues = () => {
    const initialValues = new Array(fields.length).fill(null)

    if (!initialValue?.value) return initialValues

    if (Array.isArray(initialValue.value) && initialValue.value.length > 0) {
      const firstValue = initialValue.value[0]
      if (Array.isArray(firstValue)) {
        firstValue.forEach((val, idx) => {
          if (idx < initialValues.length) {
            initialValues[idx] = val
          }
        })
        return initialValues
      }
      initialValue.value.forEach((val, idx) => {
        if (idx < initialValues.length) {
          initialValues[idx] = val
        }
      })
      return initialValues
    }

    return initialValues
  }

  const [values, setValues] = useState(getInitialValues())

  const handleUpdateInputValue = (value, index) => {
    const current = [...values]
    current[index] = value
    setValues(current)
  }

  useEffect(() => {
    const mappedValues = values.map(val => (!val ? "" : val))
    onAnswer(mappedValues)
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [values])

  const handleChange = (e, index) => {
    handleUpdateInputValue(e.target.value, index)
  }

  return (
    <Box mt={[3, 5]}>
      {fields.map((field, index) => (
        <Box mb={3} key={index}>
          <TextField
            as="textarea"
            width={1 / 1}
            label={field.label}
            value={values[index] ?? ""}
            maxLength={field.limit}
            onChange={e => handleChange(e, index)}
            autoResize
            minHeight={60}
            rows={1}
          />
        </Box>
      ))}
    </Box>
  )
}

export default ShortText
